// start:ng42.barrel
export * from './write-review.module';
export * from './write-review';
// end:ng42.barrel




// WEBPACK FOOTER //
// ./src/main/webapp/stay-mgmt/app/routes/write-review/index.ts